import axios from "axios";

axios.defaults.withCredentials = false;
axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.timeout = 60000;

export const client = axios;

function jsonConfig(config) {
  const apiKey = localStorage.getItem("X_API_KEY");

  config.headers = {
    ...config.headers,
    Accept: "application/json",
    "Content-Type":
      config.headers && config.headers["Content-Type"] ? config.headers["Content-Type"] : "application/json",
    "Access-Control-Allow-Origin": "*",
    "x-api-key": apiKey,
  };

  return config;
}

function request(config) {
  jsonConfig(config);

  return client.request(config);
}

export function login({ email, password }) {
  return request({
    url: "/auth/login",
    method: "POST",
    data: { email, password },
  });
}

export function getProfile() {
  return request({
    url: "/user/profile",
    method: "GET",
    data: {},
    headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
  });
}

export function getProfileInfo(payload) {
  return request({
    url: `/user/profile-info/${payload.userId}`,
    method: "GET",
    data: payload,
    headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
  });
}

export function getProfileFromHash(payload) {
  return request({
    url: "/user/profileFromHash",
    method: "POST",
    data: payload,
  });
}

export function updateProfile(payload) {
  return request({
    url: "/user/profile",
    method: "POST",
    data: payload,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function getClient(payload) {
  return request({
    url: `/client/details/` + localStorage.getItem("clientId"),
    method: "GET",
    data: payload,
    headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
  });
}

export function getHomePageTPlist() {
  return request({
    url: "/client/home-tp-list/" + localStorage.getItem("clientId"),
    method: "GET",
    data: {},
    headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
  });
}

export function getAllBrandTp(payload) {
  return request({
    url: "/client/allstasticsBTP/" + localStorage.getItem("clientId"),
    method: "POST",
    data: payload,
    headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
  });
}

export function addCategory(payload) {
  return request({
    url: "/category",
    method: "POST",
    data: payload,
  });
}

export function getCategories(payload) {
  return request({
    url: "/category/list/" + localStorage.getItem("clientId"),
    method: "GET",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function getBrands(payload) {
  return request({
    url: "/brand",
    method: "GET",
    data: payload,
  });
}

export function getMarketGoals(payload) {
  return request({
    url: "/market-goal/list/" + localStorage.getItem("clientId"),
    method: "GET",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function addTouchPoint(payload) {
  return request({
    url: "/touch-point",
    method: "POST",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
    timeout: 120000,
  });
}

export function updateTouchPoint(payload) {
  return request({
    url: "/touch-point",
    method: "PUT",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
    timeout: 120000,
  });
}

export function getTouchPoints(payload) {
  return request({
    url: "/touch-point/list/" + localStorage.getItem("clientId"),
    method: "GET",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function getTouchPoint(payload) {
  return request({
    url: `/touch-point/${payload.touchPointId}`,
    method: "GET",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function likeTouchPoint(payload) {
  return request({
    url: `/touch-point/like/${payload.touchPointId}`,
    method: "POST",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function favorTouchPoint(payload) {
  return request({
    url: `/touch-point/favor/${localStorage.getItem("clientId")}/${payload.touchPointId}`,
    method: "POST",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function likeTouchPointComment(payload) {
  return request({
    url: `/touch-point/like-comment`,
    method: "POST",
    data: {
      clientId: localStorage.getItem("clientId"),
      touchpointId: payload.touchpointId,
      commentId: payload.commentId,
    },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function deleteTouchPoint(payload) {
  return request({
    url: `/touch-point/${payload.touchPointId}`,
    method: "DELETE",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function addTouchPointComment(payload) {
  return request({
    url: "/touch-point/add-comment",
    method: "POST",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function editTouchPointComment(payload) {
  return request({
    url: "/touch-point/edit-comment",
    method: "POST",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function deleteTouchPointComment(payload) {
  return request({
    url: `/touch-point//delete-comment/${payload.touchpointId}/${payload._id}`,
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function getNotifications() {
  return request({
    url: "/notification/list-all",
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function getUnseenNotificationsCount() {
  return request({
    url: "notification//get-unseen-count",
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function setUnreadStatus(payload) {
  return request({
    url: "notification/set-unread-status",
    method: "POST",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function setSeenStatusBulk(payload) {
  return request({
    url: "notification/bulk-set-seen-status",
    method: "POST",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function resetPassword(payload) {
  return request({
    url: "user/reset-password",
    method: "POST",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function saveToken(payload) {
  return request({
    url: "firebase/save",
    method: "POST",
    data: payload,
    headers: {
      Authorization: `Bearer ${payload.accessToken}`,
    },
  });
}

export function getUsersTasks() {
  return request({
    url: "tasks/get-user-tasks",
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function getTask(taskId) {
  return request({
    url: `/tasks/${taskId}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function getUsers() {
  return request({
    url: "/user/list/" + localStorage.getItem("clientId"),
    method: "GET",
    data: {},
    headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
    timeout: 120000,
  });
}

export function generatePDF(payload) {
  return request({
    url: `touch-point/generate-pdf/${payload.touchPointId}/${payload.milestoneIndex}`,
    method: "GET",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      Accept: "application/pdf",
      "Content-Type": "application/pdf",
    },
    responseType: "blob",
    timeout: 120000,
  });
}

export function createMilestone(payload) {
  return request({
    url: "/milestone",
    method: "POST",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function updateMilestone(payload) {
  return request({
    url: "/milestone",
    method: "PUT",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function getTouchPointMilestone(payload) {
  return request({
    url: `/milestone/${payload.touchPointId}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function deleteMilestone(payload) {
  return request({
    url: `/milestone/${payload.touchPointId}/${payload.milestoneId}`,
    method: "DELETE",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function getOrgaColumns() {
  return request({
    url: "/orga/list/" + localStorage.getItem("clientId"),
    method: "GET",
    data: {},
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function getOrgaTasks() {
  return request({
    url: "/orga/tasks/" + localStorage.getItem("clientId"),
    method: "GET",
    data: {},
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function createOrgaTask(payload) {
  return request({
    url: "/orga/tasks",
    method: "POST",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function updateOrgaTask(payload) {
  return request({
    url: "/orga/tasks",
    method: "PUT",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function deleteOrgaTask(payload) {
  return request({
    url: `/orga/tasks/${payload.taskId}`,
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function getQuiz() {
  return request({
    url: "/quiz/get-unanswered",
    method: "GET",
    data: {},
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function answerQuiz(payload) {
  return request({
    url: "/quiz/save-answer",
    method: "POST",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function getQuizItem(quizId) {
  return request({
    url: `/quiz/item/${quizId}`,
    method: "GET",
    data: {},
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function getUserAudits() {
  return request({
    url: "/audit/get-user-audits",
    method: "GET",
    data: {},
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function saveAuditResults(payload) {
  return request({
    url: "/audit/save-audit",
    method: "POST",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function updateAuditResults(payload) {
  return request({
    url: "/audit/update-audit",
    method: "PUT",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function updateSurveyState(payload) {
  return request({
    url: "/touch-point/update-survey-state",
    method: "POST",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function saveSurveyResults(payload) {
  return request({
    url: "/market-goal-survey/save-survey",
    method: "POST",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function loginSwitch(payload) {
  return request({
    url: "/auth/login-switch",
    method: "POST",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function addAttachment(payload) {
  return request({
    url: "/touch-point/add-attachment",
    method: "POST",
    data: payload,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function deleteAttachment(payload) {
  return request({
    url: `/touch-point/delete-attachment/${payload.attachmentId}`,
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function getDailyQuest() {
  return request({
    url: "/daily-quest/get-quest",
    method: "GET",
    data: {},
    headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
  });
}

export function answerQuest(payload) {
  return request({
    url: "/daily-quest/save-quest",
    method: "POST",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function getSurvey() {
  return request({
    url: "/survey/get-unanswered",
    method: "GET",
    data: {},
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function answerSurvey(payload) {
  return request({
    url: "/survey/save-answer",
    method: "POST",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function getSurveyItem(surveyId) {
  return request({
    url: `/survey/item/${surveyId}`,
    method: "GET",
    data: {},
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function getJourneys() {
  return request({
    url: `/journey/list-all/${localStorage.getItem("clientId")}`,
    method: "GET",
    data: {},
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function getJourney(journeyId, sub) {
  return request({
    url: `/${sub ? "sub-" : ""}journey/${journeyId}`,
    method: "GET",
    data: {},
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function getJourneyChannels() {
  return request({
    url: `/journey-channel/list-all/${localStorage.getItem("clientId")}`,
    method: "GET",
    data: {},
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function putJourneyActivity(payload) {
  return request({
    url: `/journey/activity`,
    method: "PUT",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function putJourney(payload) {
  return request({
    url: "/journey",
    method: "PUT",
    data: payload,
    headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
  });
}

export function putSubJourney(payload) {
  return request({
    url: "/sub-journey",
    method: "PUT",
    data: payload,
    headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
  });
}

export function generateJourneyPDF(payload) {
  return request({
    url: `journey/generate-pdf/${payload.id}/${payload.isSubJourney}?width=${payload.width}`,
    method: "GET",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      Accept: "application/pdf",
      "Content-Type": "application/pdf",
    },
    responseType: "blob",
    timeout: 120000,
  });
}

export function loadAnalyticsForTPList(payload) {
  return request({
    url: "/touch-point/load-list-analytics",
    method: "POST",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function getScreenshot(url) {
  return request({
    url: `/script/get-screenshot?url=${url}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function addWheelPoints(payload) {
  return request({
    url: "tasks/add-wheel-points",
    method: "PUT",
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function getActivityTPs(activityId) {
  return request({
    url: `/journey/activity/${activityId}/touchpoints/`,
    method: "GET",
    data: {},
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function getActivityStats(activityId) {
  return request({
    url: `/journey/activity/${activityId}/stats/`,
    method: "GET",
    data: {},
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function getCommunityList(payload) {
  const clientId = localStorage.getItem("clientId");
  const pageIndex = payload.pageIndex || 1;
  const pageSize = payload.pageSize || 25;
  const group1 = payload.group1;
  const group2 = payload.group2;
  return request({
    url: `/user/community-list?clientId=${clientId}&pageSize=${pageSize}&group1=${group1}&group2=${group2}&pageIndex=${pageIndex}`,
    method: "GET",
    data: {},
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
}

export function getSsoStatus(email) {
  return request({
    url: `/sso/status?email=${email}`,
    method: "GET",
  });
}

export function getSsoConfig(email) {
  return request({
    url: `/sso/config/?email=${email}`,
    method: "GET",
    data: {},
  });
}

export function handleSsoUser(token, email) {
  return request({
    url: `/sso/handle-user`,
    method: "POST",
    data: { token, email },
  });
}

export default request;
